import _ from "lodash";
import axios from "axios";
import StorageService from "./StorageService";

class ApiService {
  constructor() {
    this.baseUrl = process.env.REACT_APP_API_URL;
    this.axiosParams = {
      headers: {
        Authorization: `Bearer ${StorageService.getToken()}`,
      },
      timeout: 10000,
    };
  }

  refreshHeaders() {
    this.axiosParams = {
      headers: {
        Authorization: `Bearer ${StorageService.getToken()}`,
      },
      timeout: 10000,
    };
  }

  async postData(path, payload = {}, params = null) {
    try {
      const url = this.baseUrl + path;
      const response = await axios.post(url, payload, params ? params : this.axiosParams);
      return response;
    } catch (error) {
      this.checkErrorCode(error);
      return null;
    }
  }

  async putData(path, payload, params = null) {
    try {
      const url = this.baseUrl + path;
      const response = await axios.put(url, payload, params ? params : this.axiosParams);
      return response;
    } catch (error) {
      this.checkErrorCode(error);
      return null;
    }
  }

  async getData(path, params = null) {
    try {
      const url = this.baseUrl + path;
      const response = await axios.get(url, params ? params : this.axiosParams);
      return response;
    } catch (error) {
      this.checkErrorCode(error);
      return null;
    }
  }

  async deleteData(path, params = null) {
    try {
      const url = this.baseUrl + path;
      const response = await axios.delete(url, params ? params : this.axiosParams);
      return response;
    } catch (error) {
      this.checkErrorCode(error);
      return null;
    }
  }

  checkErrorCode(error) {
    console.error(error);
    const code = _.get(error, "response.status");
    // if (code === 401) window.location.replace("/login");
  }
}

export default new ApiService();
